import ABCyaPhaser from "@abcya/abcya_phaser";
import SoundAssetKeys from "../SoundAssetKeys";
import Monster from "./Monster";

export default class HowTo3 extends Phaser.GameObjects.Container {
    constructor(scene) {
        super(scene);

        this.workingWidth = null;
        this.workingHeight = null;

        this.inst3 = null;

        this.sizeContainer = null;
        this.sizeBg = null;
        this.lblSize = null;
        this.monster = null;

        this.inst3 = ABCyaPhaser.Images.addImage(0, 0, "Label_Grow_To", this);

        this.sizeContainer = this.scene.add.container(0, 100);

        this.monster = new Monster(this.scene);
        this.monster.x = 30;
        this.sizeContainer.add(this.monster);

        this.sizeBg = ABCyaPhaser.Images.addImage(0, 0, "GoalBg", this.sizeContainer);
        this.lblSize = ABCyaPhaser.Images.addImage(0, 0, "Label_Goal", this.sizeContainer);
        this.lblSize.y = this.sizeBg.height + 10;
        this.lblSize.x = this.sizeBg.width / 2 - this.lblSize.width / 2;

        this.sizeContainer.x = (this.inst3.width - this.sizeBg.width) / 2;

        this.add(this.sizeContainer);

        this.workingWidth = this.inst3.width;
        this.workingHeight = this.lblSize.y + this.lblSize.height;
        this.monster.initSmall();
        this.monster.x = 30 + (this.monster.workingWidth / 2);
        this.monster.y = this.monster.workingHeight;
    }

    initAnimation() {
        this.monster.growFull(1200);
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._whistle_up, this.scene);
    }

    preUpdate(time, delta) {
        this.monster.tick(delta / 1000);
    }
}